module.exports = "https://p.cds.unp.clasificados.pe/logo-trome-dark-grey.055220e4124cac2b5a035d4350c87d9e.svg";